var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 16.0007C2.66659 12.4644 4.07134 9.07305 6.57183 6.57256C9.07232 4.07208 12.4637 2.66732 15.9999 2.66732C17.7509 2.66732 19.4847 3.0122 21.1024 3.68226C22.72 4.35232 24.1899 5.33445 25.428 6.57256C27.9285 9.07305 29.3333 12.4644 29.3333 16.0007C29.3333 19.5369 27.9285 22.9283 25.428 25.4287C22.9275 27.9292 19.5361 29.334 15.9999 29.334C14.249 29.334 12.5151 28.9891 10.8975 28.319C9.2798 27.649 7.80994 26.6669 6.57183 25.4287C5.33372 24.1906 4.35159 22.7208 3.68152 21.1031C3.01146 19.4854 2.66659 17.7516 2.66659 16.0007ZM23.9999 14.6673L13.3333 14.6673L17.9999 10.0007L16.1066 8.10732L8.21325 16.0007L16.1066 23.894L17.9999 22.0007L13.3333 17.334H23.9999V14.6673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrowLeftCircle.dc9f39804a1793a7e18409e9fd74e95a.svg";
export { ForwardRef as ReactComponent };